import { IFilterCategory } from "components/Filter";
import { TRUE } from "constants/primitives";
import { VENDORS_FILTER_CATEGORIES } from "constants/vendors";
import { AppStateContext } from "core/AppStateContext";
import { ITranslationsContext } from "core/TranslationsContext";
import WidgetConfig from "helpers/init/WidgetConfig";
import { TCF_AVAILABLE_FILTERS } from "helpers/tcf/constantsTCF";
import { VendorTypes } from "helpers/tcf/TCFConsentProvider/types";

const calculateFilterBaseContent = (
  widgetConfig: WidgetConfig,
  translate: ITranslationsContext["t"],
  gvl: AppStateContext["gvl"]
): IFilterCategory[] | [] => {
  const baseFilterContent: IFilterCategory[] = [];

  // Prepare main categories
  const mainCategories: IFilterCategory = {
    id: VENDORS_FILTER_CATEGORIES,
    label: translate("vendors.types"),
    values: [],
  };

  if (widgetConfig.tcfEnabled) {
    mainCategories.values.push({
      id: VendorTypes.IAB,
      label: translate(`vendors.${VendorTypes.IAB}_vendors`),
      category: VENDORS_FILTER_CATEGORIES,
      isVisible: TRUE,
    });
  }

  mainCategories.values.push({
    id: VendorTypes.NON_IAB,
    label: translate(`vendors.${VendorTypes.NON_IAB}_vendors`),
    category: VENDORS_FILTER_CATEGORIES,
    isVisible: TRUE,
  });

  if (widgetConfig.tcfEnabled && widgetConfig.acEnabled) {
    mainCategories.values.push({
      id: VendorTypes.GOOGLE,
      label: translate(`vendors.${VendorTypes.GOOGLE}_vendors`),
      category: VENDORS_FILTER_CATEGORIES,
      isVisible: TRUE,
    });
  }

  // Push to base filters
  baseFilterContent.push(mainCategories);

  // Prepare sub filters, more detailed filters
  if (widgetConfig.tcfEnabled && gvl) {
    TCF_AVAILABLE_FILTERS.forEach((catName) => {
      const category: IFilterCategory = {
        id: catName,
        label: translate(`vendors.${catName}`),
        values: [],
      };

      const catValues = gvl[catName as keyof typeof gvl];
      if (catValues) {
        Object.entries(catValues).forEach(([index, value]) => {
          category.values.push({
            id: index,
            label: value.name,
            category: catName,
            isVisible: TRUE,
          });
        });
      }

      // Add to list of filters
      baseFilterContent.push(category);
    });
  }

  return baseFilterContent;
};

export default calculateFilterBaseContent;
